// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayerPanel_container__ibT5j","header":"PlayerPanel_header__PBrH3","flex-container":"PlayerPanel_flex-container__wHB0A","textfield":"PlayerPanel_textfield__HNP7f"};